$( document ).ready(function() {

	$.urlParam = function(name){
		var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
		if(results)
		{
			return results[1] || 0;
		}		
	}

	const client = ShopifyBuy.buildClient({
		domain: 'landing1.myshopify.com',
		storefrontAccessToken: '73afca31acaef95e6870591d23dcb7e8'
	});
	
	

	//вызываем при покупке на странице товара
	if($('.shopify-product-form').length > 0)
	{
		$(function () {
			$('.shopify-product-form').parsley()
			.on('form:submit', function() {

				client.product.fetchByHandle($("#product_handle").val()).then((product) => {
					// Do something with the product
					const input = {
						email: $("#email").val(),
						lineItems: [
							{variantId: product.variants[0].id, quantity: 1}
						],
						shippingAddress: 
							{
								address1: $("#address1").val(),
								address2: '',
								city: $("#city").val(),
								company: $("#thirdName").val(),
								country: $("#country").val(),
								firstName: $("#firstName").val(),
								lastName: $("#lastName").val(),
								phone: $("#phone").val(),
								province: 'Saint Petersburg',
								zip: $("#zip").val()
							}
					};

					client.checkout.create(input).then((checkout) => {
						Cookies.set('checkoutId', checkout.id, { expires: 1 });
						window.location.href = 'https://auth.robokassa.ru/Merchant/Index.aspx?MerchantLogin=coolitems&InvId=0&Culture=ru&Encoding=utf-8&Description=' + $("h1").text()  + '&OutSum=4900&SignatureValue=78ea17a768b7f5e96ad9721e5d1e9c63';
					});
				});
				return false;
			});
		});
	}

	
	//вызываем на странице успшеной оплаты
	if($.urlParam('inv_id'))
	{
		if(Cookies.get('checkoutId'))
		{
			const checkoutId = Cookies.get('checkoutId');
			const input = {
				note: 'Оплата прошла успешно',
				customAttributes: [
					{
						key: "inv_id", value: $.urlParam('inv_id')
					}
				]
			};

			client.checkout.updateAttributes(checkoutId, input).then((checkout) => {
				console.log(checkout);
			});
		}
	}
	
});